import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import {
  TemplatesNavigation,
  type TemplatesNavigationProps,
} from "@src/components/modules/templates/navigation";
import { ProjectTemplatesPage } from "@src/components/modules/templates/projects";
import { createFileRoute } from "@tanstack/react-router";

const currentTemplate: TemplatesNavigationProps["currentTemplate"] = {
  href: "/templates/projects",
  title: () => t`Project templates`,
};
const Page = () => (
  <MainLayout
    title={currentTemplate.title()}
    navigation={<TemplatesNavigation currentTemplate={currentTemplate} />}
  >
    <ProjectTemplatesPage template={currentTemplate} />
  </MainLayout>
);

export const Route = createFileRoute("/templates/projects")({
  component: Page,
});
